import { useEffect } from 'react';
import { usePostAuthLogoutMutation } from '../../store/backendApi';

/**
 * Platform-agnostic hook for handling sign out logic.
 * Triggers logout mutation and tracks completion state.
 */
export function useSignOut() {
  const [signOutAction, { data, isLoading }] = usePostAuthLogoutMutation();

  useEffect(() => {
    signOutAction();
  }, [signOutAction]);

  return {
    isComplete: !!data,
    isLoading,
  };
}
